import { type FC, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import styled, { createGlobalStyle } from 'styled-components';

import { NotificationsContainerID } from 'src/app/components/notifications';

const getHeight = (fullHeight: boolean, open?: boolean, height?: number): string => {
  if (!open) {
    return '0';
  }

  if (height) {
    return `${String(height)}px`;
  }

  if (fullHeight) {
    return '100%';
  }
  return 'auto';
};

type BottomDrawerProps = {
  children: ReactNode;
  fullHeight?: boolean;
  height?: number;
  marginX?: number;
  marginY?: number;
  onClose: () => void;
  open?: boolean;
  portalId?: string;
};

export const BottomDrawer: FC<BottomDrawerProps> = ({
  children,
  fullHeight = false,
  height,
  marginX = 20,
  marginY = 20,
  onClose,
  open,
  portalId,
}) => {
  const component = (
    <>
      {open && <AdjustedNotificationContainer />}
      <OverlayDiv open={open} onClick={onClose} />
      <DrawerDiv height={getHeight(fullHeight, open, height)} marginx={marginX} marginy={marginY} open={open}>
        {children}
      </DrawerDiv>
    </>
  );

  const portalEl = document.getElementById(portalId || '');
  if (portalEl) {
    return createPortal(component, portalEl);
  }

  return component;
};

const AdjustedNotificationContainer = createGlobalStyle`
  #${String(NotificationsContainerID)} {
    top: 115px;
  }
`;

const OverlayDiv = styled.div<{ open?: boolean }>`
  height: ${({ open }) => (open ? '80%' : '0')};
  position: absolute;
  width: 100%;
  z-index: var(--z-index-bottom-drawer);
  pointer-events: auto;
`;

const DrawerDiv = styled.div<{ height: string; marginx: number; marginy: number; open?: boolean }>`
  box-shadow: 0 0 18px rgba(33, 33, 33, 0.2);
  background-color: var(--color-grayscale-white);
  bottom: 0;
  height: ${({ height }) => height};
  max-height: calc(100% - ${({ marginy: marginY }) => marginY}px);
  overflow: auto;
  position: absolute;
  transition: 0.35s ease-in-out;
  width: calc(100% - ${({ marginx: marginX }) => marginX * 2}px);
  left: ${({ marginx: marginX }) => marginX}px;
  z-index: calc(var(--z-index-bottom-drawer) + 1);
  pointer-events: auto;
  border-radius: 20px 20px 0 0;
`;
